export default __webpack_public_path__ + "static/googleDriveLogo-8d07d3e94634b5fdafb16e9e12f0c946.svg";